import { render } from "./TemplateReceiveTestModal.vue?vue&type=template&id=bca3c022"
import script from "./TemplateReceiveTestModal.vue?vue&type=script&lang=js"
export * from "./TemplateReceiveTestModal.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__